import { Skeleton } from '@radix-ui/themes';
import { useMemo } from 'react';
import { getRandomWidth } from '../common';

const ApplicantCardSkeleton = () => {
  const randWidthName = useMemo(() => getRandomWidth(30, 150), []);
  const randWidthStatus = useMemo(() => getRandomWidth(30, 60), []);

  return (
    <div className={'applicant-list-item shadow-sm pr-2'}>
      <div className="score">
        <Skeleton height="2rem" width="2rem" style={{ borderRadius: '50%' }} />
      </div>
      <div className="pill-height self-center flex">
        <div>
          <Skeleton width={`${randWidthName}px`} />
        </div>
        <div className="status-row">
          <span>
            <Skeleton width={`${randWidthStatus}px`} />
          </span>
          <span className="time mr-2">
            <Skeleton width={'30px'} />
          </span>

          <span className="time">
            <Skeleton width={'30px'} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ApplicantCardSkeleton;
